import { Component } from '@angular/core';
import { FooterComponent } from '../../components/common/footer/footer.component';

@Component({
  selector: 'app-appunimarc',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './appunimarc.component.html',
  styleUrl: './appunimarc.component.scss'
})
export class AppunimarcComponent {

  isUnimarc = true;

  downloadApp() {
  const ua = navigator.userAgent;

  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  if (isIOS) {
    globalThis.location.href = 'https://apps.apple.com/cl/app/unipay/id6742227439';
    return;
  }

  if (isAndroid) {
    globalThis.location.href = 'https://play.google.com/store/apps/details?id=lat.trust.android.unipay';
    return;
  }

  // Otros dispositivos (PC)
  globalThis.location.href = 'https://play.google.com/store/apps/details?id=lat.trust.android.unipay';
}

}
